export const ALPHA_NUMERIC_CHARACTERS: RegExp = /[^a-zA-Z0-9]/;
// eslint-disable-next-line security/detect-unsafe-regex
export const VALID_EMAIL_REGEX: RegExp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

export const WHITE_SPACES = new RegExp('\\s');
